<template>
  <div>
    积分充值记录
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>